import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './RoleDetails.css';
import { roles } from '../data/roles';

function RoleDetails() {
  const { roleId } = useParams();
  
  const role = roles.find(r => r.id === roleId);
  const colors = ['#0332ff', '#835df6', '#ffd875', '#6C8DFC', '#1ab96d', '#b3d1dd'];

  if (!role) return <div>Role not found</div>;

  return (
    <div className="role-details">
      
      <div className="role-header">
        <img 
          className={`${role.id}-show playbook-role`} 
          src={`/${role.image}`} 
          alt={role.alt} 
        />
        <h2>{role.alt}</h2>
        <p>{role.tagline}</p>
      </div>
      
      <div className="role-tasks-detailed">
        {role.tasks.map((task, index) => (
          <div key={index} className="task-container">
            <div className="task-number" style={{ color: colors[index % colors.length] }}>
              {index + 1}
            </div>
            <div className="task-content">
              <h4>{task.main}</h4>
              <ul className="subtasks-list">
                {task.subtasks.map((subtask, subIndex) => (
                  <li key={subIndex}>{subtask}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
      <Link to="/?tab=team" className="back-link">← Back to Team Overview</Link>
    </div>
    
  );
}

export default RoleDetails;
